// top-level imports
import React from 'react';
import styled from 'styled-components';
// antd
import Form from 'antd/lib/form';
import Card from 'antd/lib/card';
import message from 'antd/lib/message';
// apollo
import { forgotPassword } from 'meteor-apollo-accounts';
import ApolloClient from 'ApolloClient';
import TextInput from 'components/inputs/TextInput';
import PageContainer from 'components/common/PageContainer';
import FormItem from 'components/common/FormItem';
import Button from 'components/common/Button';
import LinkText from 'components/text/LinkText';
import Icon from 'components/common/Icon';
import ErrorList from 'components/common/ErrorList';
import ErrorHelpers from '../../lib/helpers/ErrorHelpers/index';
import constants from 'lib/constants';
// import Logo from 'components/common/Logo';
// CONSTANTS & DESTRUCTURING
// ====================================
// STYLED-COMPONENTS
// ========================================
const AuthLogoContainer = styled.div`
  text-align: center;
  height: 135px;
  align-items: center;
  justify-content: center;
  display: flex;
`;

const FormContainer = styled.div`
  width: 400px;
  text-align: center;
  max-width: 100%;
  margin: auto;
  padding-top: 20px;
`;

// CONSTANTS & DESTRUCTURING
// ========================================
const LINK_STYLE = { textAlign: 'center', marginTop: 20, color: '#fff' };

const Logo = styled.img`
  height: 61px;
  margin: auto;
  margin-bottom: 20px;
`;
// STYLES
// ====================================
const SuccessCard = () => (
  <Card
    bodyStyle={{
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
    style={{ height: 257 }}
  >
    <div style={{ textAlign: 'center' }}>
      <Icon style={{ fontSize: 50, marginBottom: 10 }} type="like-o" />
      <h2 style={{ textAlign: 'center', margin: 0, color: '#000' }}>Please Check Your Email!</h2>
      <h3 style={{ textAlign: 'center', margin: 0, color: '#888' }}>
        A password reset link has been sent to your email!
      </h3>
    </div>
  </Card>
);
// INTERNAL COMPONENTS
// ====================================
const ButtonContainer = styled.div`
  text-align: center;
  margin-top: 10px;
`;

class ForgotPasswordForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      loading: false,
      emailSent: false,
      errors: [],
    };
  }

  handleSubmit(e) {
    e.preventDefault();
    let errors = [];
    this.setState({ loading: true, errors });

    this.props.form.validateFields((err, { email }) => {
      if (err) {
        return this.setState({ loading: false, submitted: false, errors });
      }
      forgotPassword({ email }, ApolloClient)
        .then(() => {
          this.setState({ loading: false, emailSent: true, errors });
          message.success('a recovery email has been sent to your inbox!', 4);
        })
        .catch(err => {
          ErrorHelpers.handleError(err);
          this.setState({ loading: false });
        });
    });
  }

  render() {
    const { form } = this.props;
    const { getFieldDecorator } = form;

    if (this.state.emailSent) {
      return <SuccessCard />;
    }

    return (
      <PageContainer>
        <AuthLogoContainer>
          {' '}
          <Logo src={constants.images.logoBlack} alt="cclariti" />
        </AuthLogoContainer>
        <FormContainer onSubmit={this.handleSubmit}>
          <FormItem hasFeedback>
            {getFieldDecorator('email', {
              rules: [
                { required: true, message: 'An email is required!' },
                { type: 'email', message: 'Please input a valid email!' },
              ],
            })(<TextInput size="large" prefix={<Icon type="mail" />} placeholder="Enter your email..." />)}
          </FormItem>
          <ButtonContainer>
            <Button
              onClick={this.handleSubmit}
              fullWidth
              loading={this.state.loading}
              disabled={this.state.loading}
              htmlType="submit"
            >
              Send Instructions
            </Button>
          </ButtonContainer>
        </FormContainer>
        <LinkText
          style={{ textAlign: 'center', marginTop: 20, color: '#fff' }}
          onClick={() => this.props.history.push('/login')}
        >
          Or Login Here
        </LinkText>

        <ErrorList errors={this.state.errors} />
        <div style={{ marginTop: 15 }} />
      </PageContainer>
    );
  }
}

export default Form.create()(ForgotPasswordForm);



// WEBPACK FOOTER //
// ./src/routes/auth-forgot-password/index.js